import { useFoundations } from '@percent/admin-dashboard/common/hooks'
import {
  usePostHogFeatureFlag,
  POSTHOG_FEATURE_FLAGS
} from '@percent/admin-dashboard/common/hooks/usePostHogFeatureFlag'
import { DetailedDisbursementsCount } from '@percent/admin-dashboard/api/actions/disbursements/disbursements.types'

const US_COUNTRY_CODE = 'USA'

export const useMultiApprovalScope = (foundationId: string, detailedCounts: DetailedDisbursementsCount[]) => {
  const multiApprovalFeatureFlag = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.AD_MULTI_APPROVAL)
  const { foundations } = useFoundations()

  const isUsFoundation = foundations?.[foundationId]?.countryCode === US_COUNTRY_CODE
  const hasBankTransferDisbursements = detailedCounts.some(({ type, count }) => type === 'bank_transfer' && count > 0)
  const isInScope = multiApprovalFeatureFlag && isUsFoundation && hasBankTransferDisbursements

  return { multiApprovalFeatureFlag, isUsFoundation, hasBankTransferDisbursements, isInScope }
}
